import type { shipments } from '$lib/tools/graphdb';

function get_progress_class(mode: 'success' | 'failed' | 'info', type: 'text' | 'bg', bold?: boolean) {

   switch (mode) {
      case 'success': {
         if (type === 'text') return `text-success ${bold ? 'font-semibold' : ''}`
         else return 'bg-success'
      }
      case 'failed': {
         if (type === 'text') return `text-destructive ${bold ? 'font-semibold' : ''}`
         else return 'bg-destructive'
      }

      case 'info': {
         if (type === 'text') return `text-primary ${bold ? 'font-semibold' : ''}`
         else return 'bg-primary'
      }
   }
}

const calculate_classes = {
   shipment_payment_progress(shipment: shipments, type: 'text' | 'bg', bold?: boolean) {

      switch (shipment.payment_status) {
         case 'fully_paid':
            return get_progress_class('success', type, bold)
         case 'partially_paid':
            return get_progress_class('info', type, bold)
         default:
            return get_progress_class('failed', type, bold)
      }
   }
}


export const shipments_utils = {
   calculate_classes
}